const baseUrl = 'https://api.paijie.com';
// const baseUrl = 'http://api.paijie';
const apiUrl = {
	v3_config_district: 'https://restapi.amap.com/v3/config/district', // 获取城市区域信息（高德）
	subjects: baseUrl + '/subjects',						   // 标的列表
	subjects_show: baseUrl + '/subjects/show',					   // 标的详情
	notes: baseUrl + '/notes',										//通知公告列表
	notes_show: baseUrl + '/notes/show',		//通知公告详情
	subject_messages_set: baseUrl + '/subject_messages/set',
	subject_messages_store: baseUrl + '/subject_messages/store',	       // 创建标的消息
	subject_auctions_store: baseUrl + '/subject_auctions/store',	       // 创建拍卖纪录
	enterprises: baseUrl + '/enterprises',					   // 企业列表
	enterprises_show: baseUrl + '/enterprises/show',				   // 企业详情信息
	customer: baseUrl + '/customer',						   // 个人信息
	customer_real: baseUrl + '/customer/real',					   // 提交认证信息
	customer_auctions: baseUrl + '/customer/auctions',				   // 实名认证信息
	customer_repass: baseUrl + '/customer/repass',				   // 修改密码
	enterprise: baseUrl + '/enterprise',				       // 机构信息
	enterprise_store: baseUrl + '/enterprise/store',				   // 机构中心信息提交
	notices: baseUrl + '/notices',						   // 拍卖公告
	notices_show: baseUrl + '/notices/show',					   // 拍卖公告详情
	send_code: baseUrl + '/puser/send',					   // 短信验证码
	login: baseUrl + '/puser/login',					   // 验证码登录
	loginpw: baseUrl + '/puser/loginpw',					   // 密码登录
	// 20250620添加
	register: baseUrl + '/puser/register',					   // 密码注册

	setpw: baseUrl + '/puser/setpw',					   // 设置密码
	banners: baseUrl + '/banners',						   // 首页banner
	sign: baseUrl + '/sign',							   // 报名信息
	sign_store: baseUrl + '/sign/store',					   // 创建报名
	shops_show: baseUrl + '/shops/show',					   // 订单详情
	upload_file: baseUrl + '/upload/file',					   // 上传文件（图片）
	update_info: baseUrl + '/customer/update_info',			   // 更新上传文件（图片）
	wxuser_signature: baseUrl + '/wxuser/signature',		     	   // 微信分享
	subjects_imgs: baseUrl + '/subjects/imgs',				       // 标的图片
	subjects_successTotal: baseUrl + '/subjects/successTotal',
	meetings: baseUrl + '/meetings',						   // 拍卖会
	meetings_show: baseUrl + '/meetings/show',		               // 拍卖会详情
	collect_store: baseUrl + '/collects/store',		               // 收藏点击
	collect: baseUrl + '/collects/index',		               // 收藏列表
	collect_get: baseUrl + '/collects/get',		               // 收藏
	subject_collect: baseUrl + '/subject_collect/store',		      // 拍品征集
	subject_collect_file: baseUrl + '/subject_collect/file',		   // 拍品征集图片上传
	vip: baseUrl + '/subject_collect/vip',		   //
	v3_staticmap: 'https://restapi.amap.com/v3/staticmap',       // 获取地图（高德）
}

const subjectTypes = [
	{ text: '全部', value: '全部' },
	{ text: '整厂', value: '整厂' },
	{ text: '二手设备', value: '二手设备' },
	{ text: '工程机械', value: '工程机械' },
	{ text: '废旧金属', value: '废旧金属' },
	{ text: '废贵金属', value: '废贵金属' },
	{ text: '废纸', value: '废纸' },
	{ text: '包装', value: '包装' },
	{ text: '印刷', value: '印刷' },
	{ text: '货存积压', value: '货存积压' },
	{ text: '化工危险废物', value: '化工危险废物' },
	{ text: '废电子电器', value: '废电子电器' },
	{ text: '手机', value: '手机' },
	{ text: '电池', value: '电池' },
	{ text: '旧轮胎与橡胶', value: '旧轮胎与橡胶' },
	{ text: '成型机', value: '成型机' },
	{ text: '库存旧衣服', value: '库存旧衣服' },
	{ text: '服装', value: '服装' },
	{ text: '鞋帽', value: '鞋帽' },
	{ text: '废玻璃', value: '废玻璃' },
	{ text: '废旧木材', value: '废旧木材' },
	{ text: '机动车', value: '机动车' },
	{ text: '土地', value: '土地' },
	{ text: '房产', value: '房产' },
	{ text: '综合类', value: '综合类' },
	{ text: '蓄电池', value: '蓄电池' },
	{ text: '线缆类', value: '线缆类' },
	{ text: '通信设备', value: '通信设备' },
	{ text: 'IT设备', value: 'IT设备' },
	{ text: '空调', value: '空调' },
	{ text: '铁件', value: '铁件' },
	{ text: '综合办公类', value: '综合办公类' },
	{ text: '通信终端', value: '通信终端' },
	{ text: '办公设备', value: '办公设备' },
	{ text: '陶瓷', value: '陶瓷' },
	{ text: '珠宝', value: '珠宝' },
	{ text: '文玩', value: '文玩' },
	{ text: '字画', value: '字画' },
	{ text: '木制品', value: '木制品' },
	{ text: '杂项', value: '杂项' },
	{ text: '艺术品', value: '艺术品' },
	{ text: '酒水', value: '酒水' },


];

const provinces = [
	{ text: '全部', value: '全部' },
	{ text: '北京市', value: '北京市' },
	{ text: '天津市', value: '天津市' },
	{ text: '上海市', value: '上海市' },
	{ text: '重庆市', value: '重庆市' },
	{ text: '河北省', value: '河北省' },
	{ text: '山西省', value: '山西省' },
	{ text: '台湾省', value: '台湾省' },
	{ text: '辽宁省', value: '辽宁省' },
	{ text: '吉林省', value: '吉林省' },
	{ text: '黑龙江省', value: '黑龙江省' },
	{ text: '江苏省', value: '江苏省' },
	{ text: '浙江省', value: '浙江省' },
	{ text: '安徽省', value: '安徽省' },
	{ text: '福建省', value: '福建省' },
	{ text: '江西省', value: '江西省' },
	{ text: '山东省', value: '山东省' },
	{ text: '河南省', value: '河南省' },
	{ text: '湖北省', value: '湖北省' },
	{ text: '湖南省', value: '湖南省' },
	{ text: '广东省', value: '广东省' },
	{ text: '甘肃省', value: '甘肃省' },
	{ text: '四川省', value: '四川省' },
	{ text: '贵州省', value: '贵州省' },
	{ text: '海南省', value: '海南省' },
	{ text: '云南省', value: '云南省' },
	{ text: '青海省', value: '青海省' },
	{ text: '陕西省', value: '陕西省' },
	{ text: '广西壮族自治区', value: '广西壮族自治区' },
	{ text: '西藏自治区', value: '西藏自治区' },
	{ text: '宁夏回族自治区', value: '宁夏回族自治区' },
	{ text: '新疆维吾尔自治区', value: '新疆维吾尔自治区' },
	{ text: '内蒙古自治区', value: '内蒙古自治区' }
];

// const account_bank = '中国建设银行股份有限公司长春华正支行';
// const account_number = '22050131006600000135';
// const account_bank = '中国邮政储蓄银行股份有限公司舒兰市支行';
// const account_number = '922000010091958888';
const account_bank = '中国邮政储蓄银行股份有限公司蛟河市支行';
const account_number = '922029013002690001';

const banks = [
	{
		account_bank: "中信银行长春分行营业部",
		account_number: "8113601012400227959",
	},
	{
		account_bank: "中国建设银行股份有限公司长春华正支行",
		account_number: "22050131006600000135",
	},
	{
		account_bank: "吉林银行长春长新街支行",
		account_number: "0110101000000943",
	},
	{
		account_bank: "中国农业银行股份有限公司长春兴隆山大楼支行",
		account_number: "07145301040006700",
	},
	{
		account_bank: "长春农村商业银行股份有限公司生态广场支行",
		account_number: "0710760011015200005602",
	},
];

export default {
	apiUrl,
	subjectTypes,
	provinces,
	banks,
	account_bank,
	account_number
}